<script setup lang="ts">
defineProps<{
  caseNumber: string;
}>();
</script>

<template>
  <div class="successful-registration-note">
    <h1 class="successful-registration-note--title">
      {{ $t("registration.user.existing.successTitle") }}
    </h1>
    <i18n-t
      keypath="registration.user.existing.successNote"
      tag="p"
      scope="global"
    >
      <template #caseNumber>
        <strong>
          {{ caseNumber }}
        </strong>
      </template>
    </i18n-t>
  </div>
</template>

<style scoped>
@import "SuccessfulRegistrationNote.css";
</style>
